import { ShieldCheck } from 'lucide-react';

/**
 * Badge "Conventionné CPAM" — réutilisable, style médical premium.
 * Variants:
 *  - solid  : fond bleu CPAM, texte blanc (par défaut)
 *  - soft   : fond clair, texte bleu CPAM (pour fond bleu/coloré)
 *  - inline : pill compact pour usage inline
 */
export default function CPAMBadge({ variant = 'solid', size = 'md', className = '' }) {
  const sizeMap = {
    sm: 'text-[10px] px-2 py-1 gap-1',
    md: 'text-xs px-3 py-1.5 gap-1.5',
    lg: 'text-sm px-4 py-2 gap-2',
  };
  const iconSizeMap = { sm: 'h-3 w-3', md: 'h-3.5 w-3.5', lg: 'h-4 w-4' };
  const variantMap = {
    solid: 'bg-[#0B2A6B] text-white border border-[#082052] shadow-sm',
    soft: 'bg-white/95 text-[#0B2A6B] border border-[#0B2A6B]/15 shadow-sm',
    outline: 'bg-transparent text-[#0B2A6B] border border-[#0B2A6B]/30',
  };
  return (
    <span
      className={`inline-flex items-center font-medium rounded-full uppercase tracking-[0.08em] ${sizeMap[size]} ${variantMap[variant]} ${className}`}
      data-testid="cpam-badge"
      aria-label="Conventionné CPAM Assurance Maladie"
      title="Conventionné CPAM Assurance Maladie"
    >
      <ShieldCheck className={iconSizeMap[size]} aria-hidden="true" />
      Conventionné CPAM
    </span>
  );
}
